export default __webpack_public_path__ + "static/media/add.2b39cbd3.svg";